import {JSX} from "react";
import ValidationRequirement from "./ValidationRequirement";

export interface ValidationRequirementEntry {
	text: string;
	checked: boolean;
}

export default function ValidationRequirements({title, entries}: {
	title: string,
	entries: ValidationRequirementEntry[]
}): JSX.Element {
	return <div className="form-validation-requirements">
		<h5>{title}</h5>
		<ul>
			{
				entries.map((entry: ValidationRequirementEntry) => <ValidationRequirement key={entry.text}
				                                                                          text={entry.text}
				                                                                          checked={entry.checked}/>)
			}
		</ul>
	</div>;
};
